import { render, staticRenderFns } from "./BarraNavegacao.vue?vue&type=template&id=a7165ac0&scoped=true"
import script from "./BarraNavegacao.vue?vue&type=script&setup=true&lang=js"
export * from "./BarraNavegacao.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BarraNavegacao.vue?vue&type=style&index=0&id=a7165ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7165ac0",
  null
  
)

export default component.exports